import { SiteCommandButton } from "modules/tenants/sections/pros/dashboard/site-commands/SiteCommandButton";
import { useSiteComponentCredentialMutation } from "@libs/api/gateways/sia/sia-ops-gateway.hooks";
import { useCommandRunner } from "../../../../../_shared-context/command-runner-context/command-runner-context";

export const UpdateSecretsCommandButton = (props: { siteId: string }) => {
  const { siteId } = props;

  const commandRunner = useCommandRunner();
  const mutation = useSiteComponentCredentialMutation();

  const handleClick = () =>
    commandRunner.runMutation("Update Site Secret", mutation, siteId);

  return (
    <SiteCommandButton
      commandName="Update Site Secret"
      onClick={handleClick}
      iconName="PageLock"
    />
  );
};
